<script>
/**
* @描述
*
* @使用方法

* @param
* 状态 status
* 1. 待审核
* 2. 已审核
* 3. 已拒绝
* 4. 已退款
*
* @LastEditTime: 最后更新时间
* 2021-10-22
* @Author: andy凌云
*/
</script>
<template>
  <div>
    <van-steps direction="vertical" :active="step">
      <van-step>
        <div class="step_title">{{ step1 }}</div>
        <div class="step_desc">{{ description1 }}</div>
        <p class="c-m-b-20 c-lightgrey">{{ time1 }}</p>
      </van-step>
      <van-step>
        <div class="step_title">{{ step2 }}</div>
        <div class="step_desc">{{ description2 }}</div>
        <p class="c-m-b-20 c-lightgrey">{{ time2 }}</p>
      </van-step>
      <van-step>
        <div class="step_title">{{ step3 }}</div>
        <div class="step_desc">{{ description3 }}</div>
        <p class="c-m-b-20 c-lightgrey">{{ time3 }}</p>
      </van-step>
    </van-steps>
  </div>
</template>

<script>
export default {
  name: "DrawStep",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      step: 1,
      step1: "",
      step2: "",
      step3: "",
      time2: "",
      time3: "",
      time1: "",
      description1: "",
      description2: "",
      description3: "",
    };
  },
  computed: {
    step() {
      let status = this.item.Status.Id;
      if (status === 1) {
        return 0;
      } else if (status === 2) {
        return 1;
      } else if (status === 3) {
        return 1;
      } else if (status === 4) {
        return 2;
      }
    },
  },
  components: {},
  created() {
    let _this = this;
    let { item } = this;
    let status = this.item.Status.Id;
    console.log(
      "%c status ",
      "background-image:color:transparent;color:blue;font-size:2em"
    );
    console.log(status);
    if (status === 1) {
      // 待审核
      _this.step = 0;
      _this.step1 = "系统审核中";
      _this.description1 = "退款申请已受理，系统将在1个工作日内完成审核。";
      _this.step2 = "微信退款处理";
      _this.description2 =
        "系统审核通过后将会把申请提交至微信，微信将会在1-3日内完成退款。";
      _this.step3 = "微信退款入账";
      _this.description3 =
        "微信退款成功后，将会在1个工作日内入账，" +
        item.Amount +
        "元将会入账至您的微信支付账户。";
    } else if (status === 2) {
      // 系统审核通过
      _this.step = 1;
      _this.step1 = "系统审核通过";
      _this.description1 = "退款申请已经提交至微信。";
      _this.time1 = item.CreateTime;
      _this.step2 = "微信退款处理中";
      _this.description2 =
        "系统审核通过后将会把申请提交至微信，微信将会在1-3日内完成退款。";
      _this.step3 = "微信退款入账";
      _this.description3 =
        "微信退款成功后，将会在1个工作日内入账，" +
        item.Amount +
        "元将会入账至您的微信支付账户";
    } else if (status === 3) {
      // 已拒绝
      _this.step = 1;
      _this.step1 = "系统审核通过";
      _this.description1 = "退款申请已经提交至微信。";
      this.time1 = item.CreateTime;
      _this.step2 = "微信受理退款失败";
      _this.description2 = "您的退款已被拒绝。";
      this.time2 = item.CloseTime;
      _this.step3 = "退款失败";
      _this.description3 = "退款失败, 拨打微信客服95017查询。";
    } else if (status === 4) {
      // 已退款
      _this.step = 2;
      _this.step1 = "系统审核通过";
      _this.description1 = "退款申请已经提交至微信。";
      this.time1 = item.CreateTime;
      _this.step2 = "微信受理退款成功";
      _this.description2 = "您的退款已被微信受理。";
      this.time2 = item.CloseTime;
      _this.step3 = "微信入账中";
      // _this.description3 = this.Amount + '元将会入账至您的微信支付账户中，具体进度请按交易号' + item.Contacts && item.Contacts[0].Mobile + '拨打微信客服95017查询。';
    }
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.step_title {
  font-size: 30px;
  margin-bottom: 8px;
  margin-top: 5px;
  font-weight: bold;
}
.step_desc {
  font-size: 26px;
  color: #666;
  margin-bottom: 15px;
}
</style>
